import { render, staticRenderFns } from "./BmDashboard.vue?vue&type=template&id=72579937&scoped=true&"
import script from "./BmDashboard.vue?vue&type=script&lang=js&"
export * from "./BmDashboard.vue?vue&type=script&lang=js&"
import style0 from "./BmDashboard.vue?vue&type=style&index=0&id=72579937&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72579937",
  null
  
)

export default component.exports